
const routes = [
  {
    path: '/', component: () => import('pages/Welcome.vue')
  },
  {
    path: '/login', component: () => import('pages/Login.vue')
  },
  {
    path: '/loginSGH', component: () => import('pages/LoginSGH.vue')
  },
  {
    path: '/loginCallCenter', component: () => import('pages/LoginCallCenter.vue')
  },
  {
    path: '/signup', component: () => import('pages/Signup.vue')
  },
  {
    path: '/signupSGH', component: () => import('pages/SignupSGH.vue')
  },
  {
    path: '/clinica',
    component: () => import('src/layouts/MainLayoutBooking.vue'),
    children: [
      { path: '', component: () => import('pages/Clinic.vue') },
    ]
  },
  {
    path: '/agendamentoSGH',
    component: () => import('src/layouts/MainLayoutBookingSGH.vue'),
    children: [
      { path: '', component: () => import('pages/BookingSGH.vue') },
    ]
  },
  {
    path: '/agendamentoCallCenterMed',
    component: () => import('src/layouts/MainLayoutBookingCallCenterMed.vue'),
    children: [
      { path: '', component: () => import('pages/BookingCallCenterMed.vue') }
    ]
  },
  {
    path: '/agendamentoCallCenter',
    component: () => import('src/layouts/MainLayoutBookingCallCenter.vue'),
    children: [
      { path: '', component: () => import('pages/BookingCallCenter.vue') },
    ]
  },
  {
    path: '/reagendamentoCallCenter',
    component: () => import('src/layouts/MainLayoutBookingCallCenterMed.vue'),
    children: [
      { path: '', component: () => import('pages/BookingCallCenterReagendamento.vue') },
    ]
  },
  {
    path: '/agendamento',
    component: () => import('src/layouts/MainLayoutBooking.vue'),
    children: [
      { path: '', component: () => import('pages/Booking.vue') },
    ]
  },
  { path: '/agradecimento', component: () => import('pages/Thanks.vue') },

  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }

]

export default routes
